import User from "@/lib/user"
import { BadgesAPI } from "@/lib/api"
import { SET_BADGES, ADD_BADGE, DELETE_BADGE } from "@/store/mutationTypes"

const state = {
  all: []
}
const getters = {
  getBadges: state => {
    return state.all
  }
}
// actions
const actions = {
  async loadBadges({ commit }) {
    commit(SET_BADGES, await BadgesAPI.list())
  },
  async addBadge({ commit }, badgeFile) {
    commit(ADD_BADGE, await BadgesAPI.create(badgeFile))
  },
  async deleteBadge({ commit }, id) {
    await BadgesAPI.delete(id)
    commit(DELETE_BADGE, id)
  }
}

// mutations
const mutations = {
  [SET_BADGES](state, badges) {
    state.all = badges
  },
  [ADD_BADGE](state, newBadge) {
    state.all.push(newBadge)
  },
  [DELETE_BADGE](state, id) {
    state.all = state.all.filter(el => el.id != id)
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
